import ReactDOM from 'react-dom/client';
import './Production.css';
import App from './App';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
